import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { TotaraApiService } from '../../../modules/shared/services/totara-api.service';
import { PopupService } from '../../services/popup.service';
import { TotaraMenuSection } from '../../../modules/shared/models/totara-menu.model';
import { ConfigurationStateService } from '../../services/configuration-state.service';
import { ErrorWarningService } from '@cms_root/app/error-warnings/services/error-warning.service';
import { ErrorWarningModalData } from '@cms_root/app/error-warnings/models/error-warning-modal-data.model';
import { SecondaryPopupService } from '@cms_root/app/shared/secondary-popup/services/secondary-popup.service';

@Component({
  selector: 'app-authenticated-layout',
  templateUrl: './authenticated-layout.component.html',
  styleUrls: ['./authenticated-layout.component.scss'],
  standalone: false
})
export class AuthenticatedLayoutComponent implements OnInit, OnDestroy {
  displayPopup: Observable<boolean>;
  displaySecondaryPopup: Observable<boolean>;
  menuData: TotaraMenuSection[];
  isMenuLoading: boolean;
  isConfigurationLoading$: Observable<boolean>;
  isSidenavHidden = false;
  errorWarningsSub = Subscription.EMPTY;

  @ViewChild('errorWarningsPopup') errorWarningsPopupTemplate: TemplateRef<any>;

  constructor(
    private readonly popupService: PopupService,
    private readonly secondaryPopupService: SecondaryPopupService,
    private readonly totaraApiService: TotaraApiService,
    private readonly configurationStateService: ConfigurationStateService,
    private readonly errorWarningService: ErrorWarningService
  ) {}

  ngOnInit(): void {
    this.displayPopup = this.popupService.getPopupStatus();
    this.displaySecondaryPopup = this.secondaryPopupService.getPopupStatus();
    this.errorWarningService.errorWarnings$.subscribe((errorWarnings) => this.displayErrorWarnings(errorWarnings));

    // TO FIX - initialized twice
    this.configurationStateService.init();
    this.isMenuLoading = true;
    this.isConfigurationLoading$ = this.configurationStateService.getConfigurationLoading();

    this.totaraApiService
      .getTotaraMenu()
      .pipe(finalize(() => (this.isMenuLoading = false)))
      .subscribe((data) => {
        this.menuData = data;
      });
  }

  ngOnDestroy(): void {
    this.errorWarningsSub.unsubscribe();
  }

  toggleSidenav(): void {
    this.isSidenavHidden = !this.isSidenavHidden;
  }

  private displayErrorWarnings(payload: ErrorWarningModalData): void {
    const data = {
      template: this.errorWarningsPopupTemplate,
      classNames: payload?.options?.popupSize || 'md',
      data: payload.data,
      uuid: payload.uuid,
      source: payload.source,
      options: payload.options
    };

    this.popupService.popupShow(data);
  }
}
